export enum StepStatus {
  Complete = 'complete',
  InProgress = 'inProgress',
  Pending = 'pending'
}
